import { createApp } from 'vue'
import router from '../routes/index'
import store from '../store/index'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueLoading from 'vue-loading-overlay'
import "./assets/reset.css"
import toast from '@/components/common/toast.js'
import App from '@/App.vue'
import './registerServiceWorker'
// import { initializeApp } from 'firebase/app'
// import { getAnalytics } from 'firebase/analytics'

// const firebaseConfig = {
//     apiKey: "AIzaSyCQhsx2H4vRVD0jdBryAZwpzPZrdkqVkP0",
//     authDomain: "credit-char-h5.firebaseapp.com",
//     projectId: "credit-char-h5",
//     storageBucket: "credit-char-h5.appspot.com",
//     messagingSenderId: "795532969479",
//     appId: "1:795532969479:web:07af63d6797e47a4c1cca2",
//     measurementId: "G-QLEJL16NRW"
// };

// const app2 = initializeApp(firebaseConfig);
// getAnalytics(app2);
// Adjust.initSdk({
// appToken: 'gm17vvbgkdfk',
// environment: 'production'
// });  

let app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(router).use(store).use(VueLoading)
app.provide('$toast', toast)
app.mount('#app')
